import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IRetrieveBookingControlsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/RetrieveBookingParams";


export class RetrieveBookingControlsAction extends BaseAction<IDefaultActionResult, IRetrieveBookingControlsActionParams> {

    override async run(): Promise<IDefaultActionResult | null> {
        const actionResult: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {
            const { e, intl, retrieveForm } = this.params!
            let { name, value } = e.target;
            let errorMessage = "";

            // Trim value only for validation, not for state update
            const trimmedValue = value.trim();

            // Validation for bookingReference field
            if (name === "bookingReference") {
                const bookingReferenceRegex = /^[a-zA-Z0-9]+$/;
                if (!trimmedValue) {
                    errorMessage = intl.formatMessage({ id: "fieldRequiredText" });
                } else if (/\s/.test(value)) {
                    errorMessage = intl.formatMessage({ id: "bookingReferenceInvalidError" });
                } else if (!bookingReferenceRegex.test(trimmedValue)) {
                    errorMessage = intl.formatMessage({ id: "bookingReferenceInvalidError" });
                }
            }
            // Validation for lastName field
            else if (name === "lastName") {
               const lastNameRegex = /^[\p{L}\p{M}\s'-]{1,50}$/u;
                if (!trimmedValue) {
                    errorMessage = intl.formatMessage({ id: "fieldRequiredText" });
                } else if (!lastNameRegex.test(trimmedValue)) {
                    errorMessage = intl.formatMessage({ id: "lastNameInvalidError" });
                }
            }

            if (errorMessage === "" || value === "") {
                updateRecoilState("retrieveFormAtom", {
                    ...retrieveForm,
                    value: {
                        ...retrieveForm.value,
                        [name]: value,
                    },
                    error: {
                        ...retrieveForm.error,
                        [name]: errorMessage,
                    },
                });
            } else {
                updateRecoilState("retrieveFormAtom", {
                    ...retrieveForm,
                    error: {
                        ...retrieveForm.error,
                        [name]: errorMessage, // Set validation error message
                    },
                });
            }


            actionResult.status = "success"
        } catch (error) {

        } finally {
            return actionResult
        }
    }
}

export const retrieveBookingControlsAction = new RetrieveBookingControlsAction(); 